import React, { type ReactNode } from 'react';
import { Error } from './';

type FormRowProps = {
  label?: ReactNode;
  error?: ReactNode;
  formField?: string;
  children?: ReactNode;
  /** `stacked` puts the label above the field for full-width controls. */
  layout?: 'inline' | 'stacked';
};

export function FormRow({
  label,
  error,
  formField,
  children,
  layout = 'inline',
}: FormRowProps) {
  if (layout === 'stacked') {
    return (
      <div
        className="flex w-full flex-col gap-2 py-2 leading-normal"
        data-form-field={formField}
      >
        {label ? (
          <label className="text-[0.9rem] font-bold uppercase tracking-[0.5px] text-[var(--foreground)] [&_svg]:text-[1.5rem] [&_svg]:text-[var(--primary)]">
            {label}
          </label>
        ) : null}
        <div className="w-full min-w-0 [&_input]:w-full [&_select]:w-full [&_textarea]:w-full">
          {children}
          {error ? <Error>{error}</Error> : null}
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex w-full flex-col gap-2 py-2 leading-normal sm:flex-row sm:gap-0 sm:leading-10"
      data-form-field={formField}
    >
      <div className="w-full shrink-0 text-left leading-normal sm:mr-4 sm:mt-[10px] sm:w-[200px] sm:text-right">
        <label className="text-[0.9rem] uppercase [&_svg]:text-[1.5rem] [&_svg]:text-[var(--primary)]">
          {label}
        </label>
      </div>
      <div className="w-full min-w-0 [&_input]:w-full [&_select]:w-full [&_textarea]:w-full">
        {children}
        {error ? <Error>{error}</Error> : null}
      </div>
    </div>
  );
}
